import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { Redirect, useLocation } from 'react-router';
import { IAuthStore } from './__legacy__/modules/auth/auth.store';
import { Auth } from './__legacy__/routes/config/Auth';

export const RequireAuth = observer(({ children }: PropsWithChildren): ReactElement => {
  const location = useLocation();

  const authStore = useInjection(IAuthStore.$);

  const redirectOptions = {
    pathname: Auth.Login.Path,
    state: { from: location },
  };

  return authStore.isAuthenticated ? <>{children}</> : <Redirect to={redirectOptions} />;
});
